import CloseIcon from "@mui/icons-material/Close";
import ColorizeIcon from "@mui/icons-material/Colorize";
import DeleteIcon from "@mui/icons-material/Delete";
import DeselectIcon from "@mui/icons-material/Deselect";
import CameraswitchIcon from "@mui/icons-material/Cameraswitch";
import {
  Backdrop,
  Card,
  Checkbox,
  CircularProgress,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Slider,
  Grid,
  Tooltip,
} from "@mui/material";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import { nanoid } from "nanoid";
import {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Draggable from "react-draggable";
import toast from "react-hot-toast";
import "react-image-crop/dist/ReactCrop.css";
import { Group, Image as KonvaImage, Layer, Line, Shape, Stage } from "react-konva";
import "react-multi-carousel/lib/styles.css";
import api from "services/api";
import "tui-image-editor/dist/tui-image-editor.css";
import useImage from "use-image";
import { dataURLtoFile, getImageDimensions, resizeImg } from "utils/imageHelper";
import { arrayToImageData, Border } from "pages/fashionlab/components/algo";
import MarchingSquaresOpt from "pages/fashionlab/components/marchingSquares";

import colors from "assets/theme/base/colors";
import qs from "query-string";
import StyledToggleButtonGroup from "pages/fashionlab/components/StyledToggleButtonGroup";
import Divider from "@mui/material/Divider";

import ToggleButton from "@mui/material/ToggleButton";
import BrushIcon from "@mui/icons-material/Brush";
import { TbEraser } from "react-icons/tb";
import DrawIcon from "@mui/icons-material/Draw";
import SaveIcon from "@mui/icons-material/Save";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import PanToolOutlinedIcon from "@mui/icons-material/PanToolOutlined";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";

import Popper from "@mui/material/Popper";
import EditImageModal from "pages/fashionlab/components/EditImageModal";
import PreviewSegmentCard from "pages/fashionlab/components/PreviewSegmentCard";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Download from "yet-another-react-lightbox/plugins/download";

const maxViewSize = 512;
const scaleBy = 1.1;
const maxZoomIn = 3;

const SegmentImageCard = forwardRef((props, ref) => {
  var segmentsRef = props.segmentsRef;
  var sketchWidth = props.sketchWidth;
  var sketchHeight = props.sketchHeight;
  var viewWidth = sketchWidth;
  var viewHeight = sketchHeight;
  const setRunningJob = props.setRunningJob;

  if (viewHeight > maxViewSize) {
    let ratioY = maxViewSize / viewHeight;
    viewHeight = maxViewSize;
    viewWidth = parseInt(Math.floor(viewWidth * ratioY));
  }

  if (viewWidth > maxViewSize) {
    let ratioX = maxViewSize / viewWidth;
    viewWidth = maxViewSize;
    viewHeight = parseInt(Math.floor(viewHeight * ratioX));
  }
  var sketchData = props.sketchData;
  var account = props.account;
  var ailab_id = props?.ailab_id;

  const [background] = useImage(sketchData?.imgurl, "anonymous", "origin");
  const [segmentData, setSegmentData] = useState([]);
  const [matchedSegment, setMatchedSegment] = useState(null);
  const [waiting, setWaiting] = useState(null);
  const [segmentImage, setSegmentImage] = useState(null);
  const [selectedSegment, setSelectedSegment] = useState(null);
  const [coloredSegment, setColoredSegment] = useState(null);
  const [inpaintMode, setInpaintMode] = useState("Move");
  const [brushSize, setBrushSize] = useState(30);
  const [brushRealSize, setBrushRealSize] = useState(30);

  const [segmentTool, setSegmentTool] = useState("Move");
  const [popAnchorEl, setPopAnchorEl] = useState(null);
  const [editImageVisible, setEditImageVisible] = useState(false);
  const [dragging, setDragging] = useState(false);
  const [scale, setScale] = useState(1);
  const [detailVisible, setDetailVisible] = useState(false);
  const [minScale, setMinScale] = useState(1);
  const [lines, setLines] = useState([]);
  const [dragPos, setDragPos] = useState({});
  const [segImage, setSegImage] = useState(null);
  const [matchImage, setMatchImage] = useState(null);
  const [reverseFlag, setReverseFlag] = useState(false);

  const popOpen = Boolean(popAnchorEl);

  const segmentImgRef = useRef(null);
  const isDrawing = useRef(false);
  const runningRef = useRef(false);
  const fillColorRef = useRef(false);
  const lineRef = useRef(null);
  const shapeRef = useRef(null);
  const imageRef = useRef(null);

  const drawSegmentRef = useRef(null);
  const matchedSegmentRef = useRef(null);
  const canvasTargetRef = useRef(null);

  const task_type = props?.jobconf?.task_type;

  const method = "sam";
  var cprompt = method === "fastsam" ? prompt : "";
  var segKey = sketchData.imgurl + "_" + method + "_" + cprompt;

  //console.log('selectedSegment', selectedSegment)
  useImperativeHandle(
    ref,
    () => ({
      selectedSegment: selectedSegment,
      setSelectedSegment: setSelectedSegment,
      segmentImage: segmentImage,
    }),
    [selectedSegment, segmentImage]
  );

  useEffect(() => {
    if (props.sketchData) {
      fitStageIntoParentContainer();
    }
  }, [props.sketchData, props?.jobconf?.task_type]);

  useEffect(() => {
    setBrushRealSize(brushSize / scale);
  }, [scale, brushSize]);

  useEffect(() => {
    if (segmentsRef.current[segKey]) {
      return;
    }

    // if (props?.jobconf?.task_type == "gen.flat.inpaint" && sketchData?.imgurl) {
    //   if (!runningRef.current && background) {
    //     loadSegments("sam", sketchData.imgurl);
    //   }
    // }
  }, [props?.jobconf]);

  useEffect(() => {
    if (segmentsRef.current[segKey] && background) {
      setSegmentData(JSON.parse(JSON.stringify(segmentsRef.current[segKey])));
      setSegmentImage(null);
      setLines([]);
    } else {
      setSegmentData([]);
      setSelectedSegment(null);
      setColoredSegment(null);
      setMatchedSegment(null);
      setSegmentImage(null);
      setLines([]);
    }
  }, [background]);

  const handleClick = (e) => {
    if (e.evt.button === 2) return;
    if (!matchedSegment || inpaintMode !== "Click") return;
    var segment = null;
    if (selectedSegment?.maskArea && matchedSegment?.maskArea) {
      const stage = e.target.getStage();
      const point = stage.getPointerPosition();
      const scaleX = stage.scaleX();
      const scaleY = stage.scaleY();

      var x = Math.max(0, Math.min(sketchWidth - 1, Math.round((point.x - stage.x()) / scaleX)));
      var y = Math.max(0, Math.min(sketchHeight - 1, Math.round((point.y - stage.y()) / scaleY)));

      var minus = selectedSegment.maskArea[x * sketchHeight + y] == 1;
      let newSelectedSegment = { ...selectedSegment };

      for (let i = 0; i < matchedSegment.maskArea.length; i++) {
        if (matchedSegment.maskArea[i] == 1) {
          if (minus == true) {
            //remove segment
            newSelectedSegment.maskArea[i] = 0;
          } else {
            //add segment
            newSelectedSegment.maskArea[i] = 1;
          }
        }
      }
      const area = newSelectedSegment.maskArea.filter((m) => m > 0).length;
      newSelectedSegment.area = area;
      //var result = combineSegment(selectedSegment, matchedSegment, minus);

      segment = newSelectedSegment;
    } else {
      segment = matchedSegment;
      console.log(matchedSegment);
    }
    setSelectedSegment(segment);
  };

  const handleMouseDown = (e) => {
    const stage = e.target.getStage();
    const point = stage.getPointerPosition();
    const scaleX = stage.scaleX();
    const scaleY = stage.scaleY();
    var x = Math.max(0, Math.min(sketchWidth - 1, Math.round((point.x - stage.x()) / scaleX)));
    var y = Math.max(0, Math.min(sketchHeight - 1, Math.round((point.y - stage.y()) / scaleY)));

    if (segmentTool == "Move") {
      setDragPos({ x, y });

      setDragging(true);
    } else if (inpaintMode !== "Click" && e.evt.button === 0 && !isDrawing.current) {
      isDrawing.current = true;

      setLines([...lines, { tool: segmentTool, points: [x, y], brushSize: brushRealSize }]);
    }
  };

  useEffect(() => {
    drawSegmentImage();
  }, [selectedSegment, lines, segImage]);

  const drawSegmentImage = async () => {
    if (!selectedSegment && lines.length == 0) {
      setSegmentImage(null);
      return;
    }
    if (!imageRef?.current) {
      return;
    }

    const stage = imageRef.current.getStage();
    const pos = stage.position();
    var canvas1 = imageRef.current.toCanvas({
      x: pos.x,
      y: pos.y,
      width: sketchWidth * scale,
      height: sketchHeight * scale,
    }); //original image

    const dw = canvas1.width;
    const dh = canvas1.height;

    const rw = sketchWidth * minScale; //resized new canvas width
    const rh = sketchHeight * minScale; //resized new canvas height

    let canvasTemp1 = document.createElement("canvas");
    var ctx_t1 = canvasTemp1.getContext("2d");
    canvasTemp1.width = rw;
    canvasTemp1.height = rh;
    ctx_t1.drawImage(canvas1, 0, 0, dw, dh, 0, 0, rw, rh);

    let nMaskImage1 = ctx_t1.getImageData(0, 0, rw, rh);

    let canvasTarget = document.createElement("canvas"); // result segmented image
    var t_ctx = canvasTarget.getContext("2d");
    canvasTarget.width = rw;
    canvasTarget.height = rh;

    let nMaskImage3 = null; //maskImage3 after resized
    let canvas3;
    if (drawSegmentRef?.current) {
      canvas3 = drawSegmentRef?.current?.toCanvas({
        x: pos.x,
        y: pos.y,
        width: sketchWidth * scale,
        height: sketchHeight * scale,
      });

      if (canvas3) {
        let canvasTemp3 = document.createElement("canvas");
        var ctx_t3 = canvasTemp3.getContext("2d");
        canvasTemp3.width = rw;
        canvasTemp3.height = rh;
        ctx_t3.drawImage(canvas3, 0, 0, dw, dh, 0, 0, rw, rh);

        nMaskImage3 = ctx_t3.getImageData(0, 0, rw, rh);
      }
    }

    let nMaskImage2 = null; //drawed segments after resized
    if (lineRef?.current && lines.length > 0) {
      var canvas2 = lineRef.current.toCanvas({
        x: pos.x,
        y: pos.y,
        width: sketchWidth * scale,
        height: sketchHeight * scale,
      });
      if (canvas2) {
        let canvasTemp2 = document.createElement("canvas");
        var ctx_t2 = canvasTemp2.getContext("2d");
        canvasTemp2.width = rw;
        canvasTemp2.height = rh;
        ctx_t2.drawImage(canvas2, 0, 0, dw, dh, 0, 0, rw, rh);

        nMaskImage2 = ctx_t2.getImageData(0, 0, rw, rh);
      }
    }

    for (let j = 0; j < nMaskImage1.data.length; j += 4) {
      let sum = 0;
      if (nMaskImage2?.data) {
        const r2 = nMaskImage2.data[j];
        const g2 = nMaskImage2.data[j + 1];
        const b2 = nMaskImage2.data[j + 2];
        const a2 = nMaskImage2.data[j + 3];
        sum = sum + r2 + g2 + b2;
      }
      if (nMaskImage3?.data) {
        const r2 = nMaskImage3.data[j];
        const g2 = nMaskImage3.data[j + 1];
        const b2 = nMaskImage3.data[j + 2];
        const a2 = nMaskImage3.data[j + 3];

        sum = sum + r2;
      }

      if (reverseFlag) {
        if (sum > 0) {
          // replace unmask area
          //using src image pixel data to replace target image data in unmasked area
          nMaskImage1.data[j] = 0; //red
          nMaskImage1.data[j + 1] = 0; //green
          nMaskImage1.data[j + 2] = 0; //blue
          nMaskImage1.data[j + 3] = 0; //alpha
        }
      } else {
        if (sum == 0) {
          // replace unmask area
          //using src image pixel data to replace target image data in unmasked area
          nMaskImage1.data[j] = 0; //red
          nMaskImage1.data[j + 1] = 0; //green
          nMaskImage1.data[j + 2] = 0; //blue
          nMaskImage1.data[j + 3] = 0; //alpha
        }
      }
    }

    t_ctx.putImageData(nMaskImage1, 0, 0);
    var dataURL = canvasTarget.toDataURL();
    //console.log(dataURL);
    setSegmentImage(dataURL);

    //document.removeChild(canvas)
    canvas1 = null;
    canvas2 = null;
    //canvas3 = null;
    canvasTarget = null;
  };

  const reverseMaskImage = async () => {
    //reverse the selected area
    if (!imageRef?.current) {
      return;
    }
    setSegmentImage(null);

    const stage = imageRef.current.getStage();
    const pos = stage.position();
    var canvas1 = imageRef.current.toCanvas({
      x: pos.x,
      y: pos.y,
      width: sketchWidth * scale,
      height: sketchHeight * scale,
    }); //original image

    const dw = canvas1.width;
    const dh = canvas1.height;

    let canvasTemp1 = document.createElement("canvas");
    var ctx_t1 = canvasTemp1.getContext("2d");
    canvasTemp1.width = dw;
    canvasTemp1.height = dh;
    ctx_t1.drawImage(canvas1, 0, 0, dw, dh);

    let nMaskImage1 = ctx_t1.getImageData(0, 0, dw, dh);

    let canvasMask = document.createElement("canvas"); // result segmented image
    var m_ctx = canvasMask.getContext("2d");
    canvasMask.width = dw;
    canvasMask.height = dh;

    const img = new Image();

    // Set the image source to the data URI
    img.src = segmentImage;

    // Ensure the image is fully loaded
    img.onload = function () {
      m_ctx.drawImage(img, 0, 0, dw, dh);
      let maskImage = m_ctx.getImageData(0, 0, dw, dh);

      for (let j = 0; j < nMaskImage1.data.length; j += 4) {
        if (maskImage?.data) {
          const r2 = maskImage.data[j];
          const g2 = maskImage.data[j + 1];
          const b2 = maskImage.data[j + 2];
          const a2 = maskImage.data[j + 3];

          if (r2 > 0) {
            nMaskImage1.data[j] = 0; //red
            nMaskImage1.data[j + 1] = 0; //green
            nMaskImage1.data[j + 2] = 0; //blue
            nMaskImage1.data[j + 3] = 0; //alpha
          }
        }
      }

      m_ctx.putImageData(nMaskImage1, 0, 0);
      var dataURL = canvasMask.toDataURL();
      //console.log(dataURL);
      setSegmentImage(dataURL);

      //setLines([]);
      canvasMask = null;
    };

    if (lineRef?.current) {
      var canvas2 = lineRef.current.toCanvas({
        x: pos.x,
        y: pos.y,
        width: sketchWidth * scale,
        height: sketchHeight * scale,
      });
      if (canvas2) {
        var ctx_t2 = canvas2.getContext("2d");
        let lineMaskImage = ctx_t2.getImageData(0, 0, dw, dh);

        for (let j = 0; j < lineMaskImage.data.length; j += 4) {
          if (lineMaskImage.data[j] > 0) {
            //red > 0
            lineMaskImage.data[j] = 0;
            lineMaskImage.data[j + 3] = 0;
          } else {
            lineMaskImage.data[j] = 255;
            lineMaskImage.data[j + 3] = 130;
          }
        }
        console.log(lineMaskImage);
        ctx_t2.putImageData(lineMaskImage, 0, 0);
      }
    }
  };

  const handleMouseUp = (e) => {
    if (isDrawing.current) {
      isDrawing.current = false;
    }
    if (dragging) {
      setDragging(false);
    }
  };

  const handleMouseMove = (e) => {
    if (segmentTool == "Brush" || segmentTool == "Eraser") {
      // change cursor icon
      const mouseY = e.evt.clientY - (brushRealSize / 2) * scale;
      const mouseX = e.evt.clientX - (brushRealSize / 2) * scale;
      const elem = document.getElementById("my-circle-cursor-id");
      if (elem) {
        elem.style.setProperty("left", mouseX + "px");
        elem.style.setProperty("top", mouseY + "px");
      }
    }
    const stage = e.target.getStage();
    const point = stage.getPointerPosition();
    const scaleX = stage.scaleX();
    const scaleY = stage.scaleY();

    var x = Math.max(0, Math.min(sketchWidth - 1, Math.round((point.x - stage.x()) / scaleX)));
    var y = Math.max(0, Math.min(sketchHeight - 1, Math.round((point.y - stage.y()) / scaleY)));
    if (isDrawing.current) {
      let lastLine = lines[lines.length - 1] || {};
      // add point
      if (!lastLine.points) {
        lastLine.points = [];
      }
      lastLine.points = lastLine.points.concat([x, y]);

      // replace last
      lines.splice(lines.length - 1, 1, lastLine);
      setLines(lines.concat());

      return;
    } else if (segmentTool == "Move" && dragging) {
      let sx = stage.x(); //stage x coordinate
      let sy = stage.y();
      if (isNaN(sx) || isNaN(sy)) {
        stage.position({ x: 0, y: 0 });
      } else {
        let nx = sx - (dragPos.x - x); //new x coordinate
        let ny = sy - (dragPos.y - y);
        let sw = stage.width(); //stage width
        let sh = stage.height();
        if (nx > 0) nx = 0;
        if (ny > 0) ny = 0;
        let nsw = sw * (1 - scaleX / minScale);
        let nsh = sh * (1 - scaleX / minScale);

        if (nx < nsw) nx = nsw;
        if (ny < nsh) ny = nsh;

        let newPos = {
          x: nx,
          y: ny,
        };

        stage.position(newPos);
      }

      return;
    }

    if (inpaintMode !== "Click") {
      return;
    }

    if (segmentData.length === 0) return;
    /*if (selectedSegment && selectedSegment.maskArea[x * sketchHeight + y] == 1) {
        setMatchedSegment(null);
        return;
      }*/

    var result = null;
    for (var segment of segmentData) {
      //console.log('x', x, 'y', y, 'segment.maskArea[x * height + y]', segment.maskArea.slice(x * height, x * height + height))
      if (segment.maskArea[x * sketchHeight + y] == 1) {
        if (segment.color) {
          setMatchedSegment(null);
          return;
        }
        if (!result || result.area > segment.area) {
          result = segment;
        }
      }
    }

    setMatchedSegment(result);
  };

  const saveSegmentImg = async () => {
    setWaiting("Saving image...");
    setMatchedSegment(null);
    try {
      await new Promise((resolve) => setTimeout(resolve, 300));
      var sketch = document.getElementById("stage_parent");
      const uri = sketch?.childNodes[0]?.childNodes[0]?.childNodes[0]?.toDataURL();
      const file = dataURLtoFile(uri, nanoid());
      var blob = await resizeImg(file, sketchWidth, sketchHeight);
      var file2 = new File([blob], file.name, { type: file.type });
      const uploadedImg = await api.uploads
        .create([file2], {}, ailab_id ? ailab_id : "segment-image")
        .then(({ data }) => {
          const uploaded = data.uploads.map(({ url }) => url);
          return uploaded;
        })
        .catch((err) => {
          console.log(err);
          setWaiting(null);
          toast.error("Save image failed!");
        });
      if (uploadedImg.length === 1) {
        var url = uploadedImg[0];
        const { width, height } = await getImageDimensions(url);
        props.setSketchData({ ...sketchData, imgurl: url, width: width, height: height });
        props.setIsDirty(true);
      }
      setWaiting(null);
    } catch (err) {
      setWaiting(null);
    }
  };

  const reset = () => {
    var newsegmentData = segmentData.map((s) => {
      return { ...s, color: undefined };
    });
    setSegmentData(newsegmentData);
    setSelectedSegment(null);
    setColoredSegment(null);
  };

  const handleSegmentTool = (event, value) => {
    if (value !== null) {
      if (["Click", "Brush", "Eraser"].includes(value)) {
        setSegmentTool(value);
        setInpaintMode(value);
      } else {
        if (value == "clear") {
          if (selectedSegment) reset();
          setSegmentImage(null);
          setLines([]);
        } else if (value == "fill-color") {
          if (selectedSegment) {
            setMatchedSegment(null);
            //setShowColorDialog(true);
            if (fillColorRef) {
              fillColorRef.current.focus();
              fillColorRef.current.click();
            }
          } else {
            return toast.error("Please select the designated area first");
          }
        } else if (value == "brush-setting") {
          //handle in child button
        } else if (value == "Move") {
          setSegmentTool("Move");
          setInpaintMode("Move");
        } else if (value == "reverse-select") {
          setReverseFlag(!reverseFlag);
          reverseMaskImage();
        }
      }
    }
  };

  const handleSaveSegmentedImage = async (uri) => {
    setWaiting("Saving image...");

    const file = dataURLtoFile(uri, nanoid());
    try {
      const uploadedImg = await api.uploads
        .create([file], {}, ailab_id ? ailab_id : "sub-segment-image")
        .then(({ data }) => {
          const uploaded = data.uploads.map(({ url }) => url);
          return uploaded;
        })
        .catch((err) => {
          console.log(err);
          setWaiting(null);
          toast.error("Save image failed!");
        });
      if (uploadedImg.length === 1) {
        var url = uploadedImg[0];
        const oldSegmentImg = props.extra?.segment_imgs || {};
        if (sketchData.imgurl) {
          if (oldSegmentImg[sketchData.imgurl]) {
            oldSegmentImg[sketchData.imgurl].push(url);
          } else {
            oldSegmentImg[sketchData.imgurl] = [url];
          }
        }
        oldSegmentImg[sketchData.imgurl];
        props.setExtra((prev) => ({ ...prev, segment_imgs: oldSegmentImg }));
        props.setIsDirty(true);
      }
      setWaiting(null);
    } catch (err) {
      console.log(err);
      setWaiting(null);
    }
  };

  const handlePreviewTool = (previewTool) => {
    switch (previewTool) {
      case "close":
        props.setSketchData(null);

        break;
      case "thumb-up":
        toast("Thumb Up!", { icon: "👍" });
        break;
      case "thumb-down":
        toast("Thumb Down!", { icon: "👎" });
        break;
      default:
        break;
    }
  };

  // A function that sets the orientation state of the tabs.
  function fitStageIntoParentContainer() {
    var container = document.querySelector("#stage-parent");

    // now we need to fit stage into parent container
    var containerWidth = container.offsetWidth;
    var containerHeight = container.offsetHeight;

    // but we also make the full scene visible
    // so we need to scale all objects on canvas

    if (segmentImgRef?.current && containerWidth > 0 && containerHeight > 0) {
      var scaleX = containerWidth / sketchWidth;

      const stage = segmentImgRef.current;

      stage.width(parseInt(sketchWidth * scaleX));
      stage.height(parseInt(sketchHeight * scaleX));
      stage.scale({ x: scaleX, y: scaleX });
      stage.position({ x: 0, y: 0 });
      setMinScale(scaleX);
      setScale(scaleX);
    }
  }
  useEffect(() => {
    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", fitStageIntoParentContainer);

    // Call the handleTabsOrientation function to set the state with the initial value.
    fitStageIntoParentContainer();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", fitStageIntoParentContainer);
  }, [props.viewType, sketchData?.imgurl]);

  const handleStageOnWheel = (e) => {
    e.evt.preventDefault();

    // how to scale? Zoom in? Or zoom out?
    let direction = e.evt.deltaY > 0 ? 1 : -1;

    // when we zoom on trackpad, e.evt.ctrlKey is true
    // in that case lets revert direction
    if (e.evt.ctrlKey) {
      direction = -direction;
    }
    const stage = e.currentTarget;
    handleZoomStage(stage, direction);
  };

  const handleClickZoom = (direction) => {
    if (segmentImgRef?.current) {
      const stage = segmentImgRef.current;
      handleZoomStage(stage, direction, "click");
    }
  };

  const handleZoomStage = (stage, direction, zoomPos = "pointer") => {
    if (stage) {
      var oldScale = stage.scaleX();
      var pointer = stage.getPointerPosition();
      let width = stage.width();
      let height = stage.height();

      var mousePointTo = {
        x: (pointer.x - stage.x()) / oldScale,
        y: (pointer.y - stage.y()) / oldScale,
      };

      if (direction > 0 && oldScale >= maxZoomIn) {
        return;
      }

      if (direction < 0 && oldScale <= minScale) {
        stage.position({ x: 0, y: 0 });
        return;
      }

      var newScale = direction > 0 ? oldScale * scaleBy : oldScale / scaleBy;
      stage.scale({ x: newScale, y: newScale });
      setScale(newScale);
      let newPos = {
        //default zoom in/out position is center of the stage
        x: (width * (1 - newScale / minScale)) / 2,
        y: (height * (1 - newScale / minScale)) / 2,
      };

      if (zoomPos == "pointer") {
        newPos = {
          //using pointer position as zoom in/out position
          x: pointer.x - mousePointTo.x * newScale,
          y: pointer.y - mousePointTo.y * newScale,
        };
      }

      newPos.x = Math.min(newPos.x, 0);
      newPos.x = Math.max(newPos.x, width * (1 - newScale / minScale));
      newPos.y = Math.min(newPos.y, 0);
      newPos.y = Math.max(newPos.y, height * (1 - newScale / minScale));
      stage.position(newPos);
    }
  };

  const toolBarIconStyle = {
    width: { xs: 16, sm: 16, md: 22, lg: 22 },
    height: { xs: 16, sm: 16, md: 22, lg: 22 },
  };
  const toolBarTextStyle = {
    fontSize: { xs: 10, sm: 10, md: 12, lg: 12 },
    display: { xs: "none", sm: "none", md: "block", lg: "block" },
    lineHeight: 1.1,
  };

  const renderDefaultPointer = () => {
    if (task_type == "gen.flat.inpaint" && (segmentTool == "Brush" || segmentTool == "Eraser")) {
      return "none"; // using customized pointer icon, so we need hide the default one
    } else if (segmentTool == "Move") {
      if (dragging) {
        return "grabbing";
      } else {
        return "grab";
      }
    } else {
      return "pointer";
    }
  };

  useEffect(() => {
    // Without SAM, selectedSegment stays null — do not draw a full-canvas "empty" overlay;
    // that KonvaImage layer was covering the real photo (Local Refinement looked blank).
    if (!selectedSegment) {
      setSegImage(null);
      return;
    }
    let color = [255, 0, 0, 100];
    drawSegment(selectedSegment, "select", color, setSegImage);
  }, [selectedSegment]);

  useEffect(() => {
    if (!matchedSegment) {
      setMatchImage(null);
      return;
    }
    let color = [0, 0, 255, 100];
    drawSegment(matchedSegment, "match", color, setMatchImage);
  }, [matchedSegment]);

  const drawSegment = (segment, mode, color, callback = () => {}) => {
    let imageData;
    if (segment) {
      imageData = arrayToImageData(segment.maskArea, segment.width, segment.height, color);
    } else {
      let arr = new Uint8ClampedArray(4 * sketchWidth * sketchHeight).fill(0);
      imageData = new ImageData(arr, sketchHeight, sketchWidth);
    }

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = sketchWidth;
    canvas.height = sketchHeight;
    ctx?.putImageData(imageData, 0, 0);
    let imageObj = new Image();
    imageObj.src = canvas.toDataURL();

    imageObj.onload = function () {
      if (mode == "select") {
        var canvas = document.createElement("canvas");
        let width = imageObj.width;
        let height = imageObj.height;
        canvas.width = width;
        canvas.height = height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(imageObj, 0, 0);
        const data4 = ctx.getImageData(0, 0, width, height).data, // Uint8ClampedArray
          len = width * height,
          data = new Uint8Array(len);
        for (let i = 0; i < len; ++i) {
          data[i] = data4[i << 2];
        }
        // let outlinePoints = MarchingSquaresOpt.getBlobOutlinePoints(data, width, height);
        // setSegmentBorderPoints(outlinePoints);
      }
    };

    callback(imageObj);
  };

  return (
    <SuiBox minHeight={510}>
      <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={waiting !== null}>
        <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
        <SuiTypography variant="h6" fontWeight="medium" color="info">
          {waiting}
        </SuiTypography>
      </Backdrop>

      <Grid container sx={{ px: 4 }}>
        <Grid
          item
          xs={12}
          sm={task_type == "gen.flat.inpaint" ? 6 : 12}
          md={task_type == "gen.flat.inpaint" ? 6 : 12}
          lg={task_type == "gen.flat.inpaint" ? 6 : 12}
        >
          <SuiBox
            display="flex"
            justifyContent="center"
            sx={{ width: "100%", mt: 1, px: 2 }}
            onMouseLeave={() => setPopAnchorEl(null)}
          >
            <SuiBox
              position="relative"
              className="hover-parent"
              id={"stage-parent"}
              sx={{ width: "100%", maxWidth: viewWidth, maxHeight: viewHeight }}
            >
              <SuiBox
                sx={{
                  cursor: renderDefaultPointer(),
                }}
                id={"stage_parent"}
                onMouseLeave={() => setMatchedSegment(null)}
                className="hover-image"
              >
                <div
                  id="my-circle-cursor-id"
                  className="my-circle-cursor hover-image-children"
                  style={{
                    width: brushRealSize * scale,
                    height: brushRealSize * scale,
                    display:
                      task_type == "gen.flat.inpaint" &&
                      (segmentTool == "Brush" || segmentTool == "Eraser")
                        ? "block"
                        : "none",
                  }}
                ></div>

                <Stage
                  ref={segmentImgRef}
                  className="konva"
                  width={viewWidth}
                  height={viewHeight}
                  onMouseDown={handleMouseDown}
                  onMouseup={handleMouseUp}
                  onMousemove={handleMouseMove}
                  onWheel={handleStageOnWheel}
                  onClick={handleClick}
                  onMouseLeave={handleMouseUp}
                >
                  <Layer ref={imageRef}>
                    <KonvaImage image={background} />
                  </Layer>
                  {/* {task_type == "gen.flat.inpaint" ? (
                    <Layer ref={shapeRef}>
                      {selectedSegment && (
                        <Segment
                          segment={selectedSegment}
                          color={"#FF0000"}
                          strokeWidth={0}
                          sketchWidth={sketchWidth}
                          sketchHeight={sketchHeight}
                          strokeColor={"#0000FF"}
                        />
                      )}
                    </Layer>
                  ) : null} */}
                  <Layer ref={drawSegmentRef}>
                    {segImage ? <KonvaImage image={segImage} /> : null}
                    {/* <Line
                      stroke={"#0000ff"}
                      opacity={0.8}
                      strokeWidth={4}
                      points={segmentBorderPoints}
                      lineCap="round"
                      lineJoin="round"
                    /> */}
                  </Layer>
                  <Layer ref={matchedSegmentRef}>
                    {matchImage ? <KonvaImage image={matchImage} /> : null}
                  </Layer>

                  {/* {task_type == "gen.flat.inpaint" ? (
                    <Layer>
                      {coloredSegment && (
                        <Segment
                          segment={coloredSegment}
                          fill={coloredSegment.color}
                          color={coloredSegment.color}
                          strokeWidth={5}
                          sketchWidth={sketchWidth}
                          sketchHeight={sketchHeight}
                        />
                      )}
                    </Layer>
                  ) : null} */}
                  {task_type == "gen.flat.inpaint" ? (
                    <Layer ref={lineRef}>
                      {lines.map((line, i) => (
                        <Line
                          key={i}
                          stroke={"#FF0000"}
                          opacity={line.tool === "Eraser" ? 1 : 0.3}
                          tension={0.5}
                          strokeWidth={line.brushSize || brushRealSize}
                          points={line.points}
                          lineCap="round"
                          lineJoin="round"
                          globalCompositeOperation={
                            line.tool === "Eraser" ? "destination-out" : "source-over"
                          }
                        />
                      ))}
                    </Layer>
                  ) : null}
                </Stage>
              </SuiBox>

              {task_type == "gen.flat.inpaint" ? (
                <SuiBox
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: { xs: -40, sm: -40, md: -76, lg: -76 },
                    margin: "auto",
                    textAlign: "center",
                  }}
                >
                  <Paper
                    elevation={1}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      border: (theme) => `1px solid ${theme.palette.divider}`,
                      flexWrap: "wrap",
                    }}
                  >
                    <StyledToggleButtonGroup
                      orientation="vertical"
                      size="medium"
                      value={segmentTool}
                      exclusive
                      onChange={handleSegmentTool}
                      aria-label="segment tool"
                    >
                      <ToggleButton value="Move" sx={{ display: "block", m: 0, p: 0.5 }}>
                        <PanToolOutlinedIcon sx={toolBarIconStyle} />
                        <SuiTypography
                          variant="body2"
                          color="dark"
                          sx={{ whiteSpace: "nowrap", mt: -0.5, ...toolBarTextStyle }}
                        >
                          Move
                        </SuiTypography>
                      </ToggleButton>
                      <ToggleButton value="Brush" sx={{ display: "block", m: 0, p: 0.5 }}>
                        <Tooltip
                          title={"Paint with your mouse to add the designated area."}
                          placement="left"
                        >
                          <BrushIcon sx={toolBarIconStyle} />
                        </Tooltip>
                        <SuiTypography
                          variant="body2"
                          color="dark"
                          sx={{ mt: -0.5, ...toolBarTextStyle }}
                        >
                          Brush
                        </SuiTypography>
                      </ToggleButton>
                      <ToggleButton value="Eraser" sx={{ display: "block", m: 0, p: 0.5 }}>
                        <Tooltip
                          title={"Erase with your mouse to clear the designated area."}
                          placement="left"
                        >
                          <SuiBox sx={{ ...toolBarIconStyle, textAlign: "center", margin: "auto" }}>
                            <TbEraser style={{ width: "100%", height: "100%" }} />
                          </SuiBox>
                        </Tooltip>
                        <SuiTypography
                          variant="body2"
                          color="dark"
                          sx={{ mt: 0, ...toolBarTextStyle }}
                        >
                          Eraser
                        </SuiTypography>
                      </ToggleButton>
                      <Divider flexItem orientation="horizontal" sx={{ my: 0.5 }} />
                      <ToggleButton
                        value="brush-setting"
                        sx={{ display: "block", m: 0, p: 0.5 }}
                        aria-describedby="brush-setting-popover"
                        onClick={(e) => {
                          dragging
                            ? null
                            : popAnchorEl
                            ? setPopAnchorEl(null)
                            : setPopAnchorEl(e.currentTarget);
                        }}
                      >
                        <BrushIcon sx={toolBarIconStyle} />
                        <SuiTypography
                          variant="body2"
                          color="dark"
                          sx={{
                            whiteSpace: "wrap",
                            maxWidth: 50,
                            mt: -0.5,
                            ...toolBarTextStyle,
                          }}
                        >
                          Brush Setting
                        </SuiTypography>
                      </ToggleButton>

                      <Divider flexItem orientation="horizontal" sx={{ my: 0.5 }} />
                      <ToggleButton value="clear" sx={{ display: "block", m: 0, p: 0.5 }}>
                        <DeselectIcon sx={toolBarIconStyle} />
                        <SuiTypography
                          variant="body2"
                          color="dark"
                          sx={{ mt: -0.5, ...toolBarTextStyle }}
                        >
                          Clear
                        </SuiTypography>
                      </ToggleButton>
                      <ToggleButton
                        value="reverse-select"
                        sx={{ display: "block", m: 0, p: 0.5 }}
                        selected={reverseFlag}
                      >
                        <CameraswitchIcon sx={toolBarIconStyle} />
                        <SuiTypography
                          variant="body2"
                          color="dark"
                          sx={{ whiteSpace: "wrap", maxWidth: 50, mt: -0.5, ...toolBarTextStyle }}
                        >
                          Reverse Select
                        </SuiTypography>
                      </ToggleButton>

                      {/* <ToggleButton value="fill-color" sx={{ display: "block", m: 0, p: 0.5 }}>
                        <ColorizeIcon sx={toolBarIconStyle} />
                        <SuiTypography
                          variant="body2"
                          color="dark"
                          sx={{
                            whiteSpace: "wrap",
                            maxWidth: 50,
                            mt: -0.5,
                            ...toolBarTextStyle,
                          }}
                        >
                          Fill Color
                        </SuiTypography>
                        <SuiBox sx={{ mt: -2 }}>
                          <input
                            ref={fillColorRef}
                            type="color"
                            value={"#FFFFFF"}
                            style={{
                              width: 20,
                              height: 20,
                              opacity: 0,
                            }}
                            onChange={(e) => {
                              if (selectedSegment) {
                                if (coloredSegment)
                                  setColoredSegment({ ...coloredSegment, color: e.target.value });
                                else
                                  setColoredSegment({
                                    ...selectedSegment,
                                    color: e.target.value,
                                  });
                                setSelectedSegment(null);
                              }
                            }}
                            onBlur={() => {
                              if (selectedSegment) {
                                saveSegmentImg();
                              }
                            }}
                          />
                        </SuiBox>
                      </ToggleButton> */}
                      <Divider flexItem orientation="horizontal" sx={{ my: 0.5 }} />
                      <ToggleButton
                        value="draw"
                        sx={{ display: "block", m: 0, p: 0.5 }}
                        onClick={(e) => (dragging ? null : setEditImageVisible(true))}
                      >
                        <DrawIcon sx={toolBarIconStyle} />
                        <SuiTypography
                          variant="body2"
                          color="dark"
                          sx={{ whiteSpace: "nowrap", mt: -0.5, ...toolBarTextStyle }}
                        >
                          Draw
                        </SuiTypography>
                      </ToggleButton>
                    </StyledToggleButtonGroup>
                  </Paper>
                </SuiBox>
              ) : (
                <SuiBox
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: { xs: -40, sm: -40, md: -76, lg: -76 },
                    margin: "auto",
                    textAlign: "center",
                  }}
                >
                  <Paper
                    elevation={1}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      border: (theme) => `1px solid ${theme.palette.divider}`,
                      flexWrap: "wrap",
                    }}
                  >
                    <StyledToggleButtonGroup
                      orientation="vertical"
                      size="medium"
                      value={segmentTool}
                      exclusive
                      onChange={handleSegmentTool}
                      aria-label="segment tool"
                    >
                      <ToggleButton value="Move" sx={{ display: "block", px: 1, py: 0.5 }}>
                        <PanToolOutlinedIcon sx={toolBarIconStyle} />
                        <SuiTypography
                          variant="body2"
                          color="dark"
                          sx={{ whiteSpace: "nowrap", mt: -0.5, ...toolBarTextStyle }}
                        >
                          Move
                        </SuiTypography>
                      </ToggleButton>

                      <ToggleButton
                        value="draw"
                        sx={{ display: "block", px: 1, py: 0.5 }}
                        onClick={(e) => (dragging ? null : setEditImageVisible(true))}
                      >
                        <DrawIcon sx={toolBarIconStyle} />
                        <SuiTypography
                          variant="body2"
                          color="dark"
                          sx={{ whiteSpace: "nowrap", mt: -0.5, ...toolBarTextStyle }}
                        >
                          Draw
                        </SuiTypography>
                      </ToggleButton>
                    </StyledToggleButtonGroup>
                  </Paper>
                </SuiBox>
              )}

              <SuiBox className="hover-children" sx={{ position: "absolute", top: 6, right: 6 }}>
                <SuiBox display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                  <IconButton
                    size="small"
                    color="dark"
                    sx={{
                      backgroundColor: "#ffffff",
                      "&:hover": {
                        backgroundColor: "#e3e3e3",
                      },
                    }}
                    onClick={(e) => {
                      if (props?.uploadSketchRef?.current) {
                        props.uploadSketchRef.current.open();
                      }
                    }}
                  >
                    <FileUploadRoundedIcon style={{ width: 20, height: 20 }} />
                  </IconButton>
                  <IconButton
                    size="small"
                    color="dark"
                    sx={{
                      backgroundColor: "#ffffff",
                      "&:hover": {
                        backgroundColor: "#e3e3e3",
                      },
                    }}
                    onClick={(e) => setDetailVisible(true)}
                  >
                    <FullscreenIcon />
                  </IconButton>
                  <IconButton
                    size="small"
                    color="dark"
                    sx={{
                      backgroundColor: "#ffffff",
                      "&:hover": {
                        backgroundColor: "#e3e3e3",
                      },
                    }}
                    onClick={() => handlePreviewTool("close")}
                  >
                    <CloseIcon style={{ width: 20, height: 20 }} />
                  </IconButton>
                </SuiBox>
              </SuiBox>

              <SuiBox className="hover-children" sx={{ position: "absolute", top: 6, left: 6 }}>
                <SuiBox display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                  <IconButton
                    size="small"
                    color="dark"
                    sx={{
                      backgroundColor: "#ffffff",
                      "&:hover": {
                        backgroundColor: "#e3e3e3",
                      },
                    }}
                    onClick={(e) => handleClickZoom(-1)}
                  >
                    <ZoomOutIcon style={{ width: 20, height: 20 }} />
                  </IconButton>
                  <IconButton
                    size="small"
                    color="dark"
                    sx={{
                      backgroundColor: "#ffffff",
                      "&:hover": {
                        backgroundColor: "#e3e3e3",
                      },
                    }}
                    onClick={(e) => handleClickZoom(1)}
                  >
                    <ZoomInIcon style={{ width: 20, height: 20 }} />
                  </IconButton>
                </SuiBox>
              </SuiBox>

              <Popper
                id="brush-setting-popover"
                open={popOpen}
                anchorEl={popAnchorEl}
                placement="right"
              >
                <Paper
                  elevation={1}
                  sx={{
                    width: 100,
                    px: 1,
                    border: (theme) => `1px solid ${theme.palette.divider}`,
                  }}
                >
                  <Slider
                    step={2}
                    value={brushSize}
                    aria-label="Default"
                    valueLabelDisplay="auto"
                    min={2}
                    max={100}
                    onChange={(e) => {
                      setBrushSize(e.target.value);
                    }}
                  />
                </Paper>
              </Popper>

              {editImageVisible ? (
                <EditImageModal
                  handleClose={() => setEditImageVisible(false)}
                  visible={editImageVisible}
                  sketchData={props?.sketchData}
                  setSketchData={props?.setSketchData}
                  setIsDirty={props?.setIsDirty}
                  stageRef={props?.stageRef}
                  sketchWidth={sketchWidth}
                  sketchHeight={sketchHeight}
                  ailab_id={ailab_id}
                />
              ) : null}
            </SuiBox>
          </SuiBox>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          display={task_type == "gen.flat.inpaint" ? "block" : "none"}
        >
          <SuiBox sx={{ pt: 1, px: 2, height: "100%", width: "auto" }}>
            <PreviewSegmentCard
              ref={canvasTargetRef}
              imgurl={segmentImage}
              scale={scale}
              imgHeight={sketchHeight}
              imgWidth={sketchWidth}
              maxViewSize={maxViewSize}
              handleSetWorkingImage={props.handleSetWorkingImage}
              handleSaveSegmentedImage={handleSaveSegmentedImage}
              setWaiting={setWaiting}
            />
          </SuiBox>
        </Grid>
      </Grid>

      <Lightbox
        open={detailVisible}
        close={() => setDetailVisible(false)}
        slides={[{ src: props?.sketchData?.imgurl }]}
        plugins={[Zoom, Download]}
        zoom={{ maxZoomPixelRatio: 3 }}
        index={0}
      />
    </SuiBox>
  );
});

export default SegmentImageCard;
